export const HAS_SOFT_REFRESHED = 'HAS_SOFT_REFRESHED';
export const HAS_NOT_SOFT_REFRESHED = 'HAS_NOT_SOFT_REFRESHED';
